import axios from "axios";
import { translations } from "../i18n/translations";

// API Configuration — always use relative paths (same-origin).
const API_URL = '';

// Axios instance with credentials
export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Auth
export const apiGetMe = () => api.get('/api/auth/me').then(r => r.data);
export const apiLogin = (email, pw) => api.post('/api/auth/login', { email, password: pw }).then(r => r.data);
export const apiRegister = (ud) => api.post('/api/auth/register', ud).then(r => r.data);
export const apiLogout = () => api.post('/api/auth/logout');
export const apiGetProfile = () => api.get('/api/auth/profile').then(r => r.data);
export const apiUpdateProfile = (data) => api.put('/api/auth/profile', data).then(r => r.data);

// Cloud / Status
export const apiCloudStatus = () => api.get('/api/cloud-status').then(r => r.data);

// Files
export const apiFilesList = (cat) => { const q = cat && cat !== 'all' ? `?category=${encodeURIComponent(cat)}` : ''; return api.get(`/api/files/list${q}`).then(r => r.data); };
export const apiCategories = () => api.get('/api/files/categories').then(r => r.data);

// Admin
export const apiApplications = (status) => api.get(`/api/admin/applications?status=${status}`).then(r => r.data);
export const apiAdminFilesList = () => api.get('/api/admin/files/list').then(r => r.data);
export const apiAdminFilesUpload = (data) => api.post('/api/admin/files/upload', data).then(r => r.data);
export const apiAdminDeleteApp = (appId) => api.delete(`/api/admin/applications/${appId}`).then(r => r.data);
export const apiAdminFilesDelete = (id) => api.delete(`/api/admin/files/${id}`).then(r => r.data);
export const apiAdminFilesUpdate = (id, data) => api.put(`/api/admin/files/${id}`, data).then(r => r.data);
export const apiAdminDealers = () => api.get('/api/admin/dealers').then(r => r.data);
export const apiAdminDeleteDealer = (email) => api.delete(`/api/admin/dealers/${encodeURIComponent(email)}`).then(r => r.data);
export const apiOnboardingStats = () => api.get('/api/admin/onboarding-stats').then(r => r.data);

// Dealer Documents
export const apiDealerDocs = () => api.get('/api/dealer/documents').then(r => r.data);
export const apiDealerDocUpload = (d) => api.post('/api/dealer/documents', d).then(r => r.data);
export const apiDealerDocDelete = (id) => api.delete(`/api/dealer/documents/${id}`).then(r => r.data);

// Sub-Admins / RBAC
export const apiSubAdmins = () => api.get('/api/admin/sub-admins').then(r => r.data);
export const apiCreateSubAdmin = (d) => api.post('/api/admin/sub-admins', d).then(r => r.data);
export const apiUpdateSubAdminPerms = (email, perms) => api.put(`/api/admin/sub-admins/${encodeURIComponent(email)}/permissions`, { permissions: perms }).then(r => r.data);
export const apiDeleteSubAdmin = (email) => api.delete(`/api/admin/sub-admins/${encodeURIComponent(email)}`).then(r => r.data);

// Invitations
export const apiInviteDealer = (data) => api.post('/api/admin/invite-dealer', data).then(r => r.data);
export const apiAdminInvitations = () => api.get('/api/admin/invitations').then(r => r.data);
export const apiResendInvitation = (data) => api.post('/api/admin/invitations/resend', data).then(r => r.data);
export const apiRevokeInvitation = (email) => api.delete(`/api/admin/invitations/${encodeURIComponent(email)}`).then(r => r.data);

// NDA
export const apiAcknowledgeNda = () => api.post('/api/auth/nda/acknowledge').then(r => r.data);
export const apiNdaStatus = () => api.get('/api/auth/nda/status').then(r => r.data);
export const apiRequestNewLink = (email) => api.post('/api/auth/request-new-link', { email }).then(r => r.data);

// Translation helper
export const apiTranslate = (lang, key) => {
  const parts = key.split('.');
  const result = parts.reduce((a, p) => a?.[p], translations[lang]);
  if (result) return result;
  if (lang !== 'en') {
    const enFallback = parts.reduce((a, p) => a?.[p], translations['en']);
    if (enFallback) return enFallback;
  }
  return key;
};

// Analytics
export const trackEvent = (eventName, params = {}) => {
  api.post('/api/analytics/event', { event_name: eventName, params }).catch(() => {});
};
